module.exports = function () {
    return {
        restrict: 'EA',
        transclude: true,
        scope: {
            name: '@',
            onEnter: '&?'
        },
        require: '^olyWizard',
        template: '<div ng-if="selected" ng-transclude></div>',
        link(scope, element, attrs, wizard) {
            wizard.addStep(scope);
            scope.selected = wizard.isCurrentStep(scope);

            scope.$watch('selected', function (isSelected) {
                if (isSelected && scope.onEnter) {
                    scope.onEnter();
                }
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/wizard/wizard-step-directive.js
 **/